import ACLeadTable from './ACLeadTable';

export default ACLeadTable;
